import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams, useLocation, generatePath, createSearchParams} from "react-router-dom";
import {Card,Alert, Col,Button, Form, Row, Spin, Checkbox, Grid} from "antd";
import {ButtonContainer} from "../../../../MaterialsDetail/style";
import {MyButton, MyText} from "../../../../../components";
import {fetchScreeningRoutinesListAction, postScreeningOneTestAction} from "../../../../../utils/store/pages/screening";
import {RootState, ROUTE_PATH, selectStore} from "../../../../../utils";
import { CheckCircleOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { CustomCheckbox, StyledButton, StyledIcon, StyledMyText } from "../../style";
import {useTranslation} from "react-i18next";
import { useEmbeddedNavigate } from "../../../../../utils/context/embed";

export const SelectedScreeningIdPageRoutines = () => {
    const { ageId, testId, childId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const {t} = useTranslation("common")
    const {name} = useParams();
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const [answers, setAnswers] = useState<{ [key: number]: number }>({});
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(0);
    const [selectedQuestionIds, setSelectedQuestionIds] = useState<number[]>([]);
    const isTablet = screens.md && !screens.xl && !screens.xxl;
    const embeddedNavigate = useEmbeddedNavigate();

    const { screening: { surveysList: surveysListState } }: RootState = useSelector(selectStore);
  
    useEffect(() => {
      if (ageId) {
        dispatch(fetchScreeningRoutinesListAction({ age: ageId * 12, list_id: testId }));
      }
    }, [ageId]);
  
    const handleGoBack = () => {
      embeddedNavigate(-1);
    };

    const getYearLabel = (age: any) => {
    const lastDigit = age % 10;
    const lastTwoDigits = age % 100;
  
    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return t("ages2");
    if (lastDigit === 1) return t("ages1");
    if (lastDigit >= 2 && lastDigit <= 4) return t("ages");
    return t("ages2");
  };
  
  
    const handleCheckboxChange = (questionId: number, isChecked: boolean) => {
  setAnswers((prevAnswers) => {
    if (isChecked) {
      return { [questionId]: 1 };
    }
    return {};
  });

  setSelectedQuestionIds((prevSelectedIds) => {
    if (isChecked) {
      return [questionId];
    } else {
      return [];
    }
  });
};

  const handleNext = () => {
    const selectedQuestionIds = Object.keys(answers).map(Number);
    const path = {
      pathname: generatePath(ROUTE_PATH.SCREENING_CURRENT_TEST_WITH_AGE_PROCESSING, {ageId, testId, name, childId}),
      // @ts-ignore
      search: createSearchParams({
        routesIdx: JSON.stringify(selectedQuestionIds),
      }).toString(),
    }

    embeddedNavigate(path);
  };

    const questions = surveysListState?.data?.surveys || [];
  
    const currentQuestion = questions[currentQuestionIndex];
  
    return (
      <>
        <Row justify="center">
          <Col span={20}>
            <Row align="middle" justify="space-between" style={{ marginBottom: 26, padding: '0px', height: screens.xs ? 'auto' : '60px' }}>
              {screens.xs ? (
                <>
                <Col span={24} style={{marginBottom: 12}}>
              
                <Row align="middle">
                                            <Col span={3}>
                                              <ButtonContainer onClick={handleGoBack}>
                                                <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                                              </ButtonContainer>
                                            </Col>
                                            <Col span={21}>
                                              <MyText
                                                color="rgba(19, 15, 38, 1)"
                                                size={26}
                                                weight={800}
                                                style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                                              >
                                                {`${t("selfDiagnosis")}`}
                                              </MyText>
                                            </Col>
                </Row>
                </Col>
                                        
                <Row style={{ background: '#fff', borderRadius: '16px', padding: '10px 16px', border: '1px solid rgba(229, 233, 242, 1)' }}>
                  <MyText color="rgba(10, 3, 60, 1)" weight={700} size={32} style={{ fontFamily: 'Nunito', lineHeight: '40px' }}>
                  {`${ageId} ${getYearLabel(ageId)}`}
                  </MyText>
                </Row>
                </>
              ) : (
                <>         
                <Row align="middle">

                                            <ButtonContainer onClick={handleGoBack}>
                                              <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                                            </ButtonContainer>
                                            <MyText
                                              color="rgba(19, 15, 38, 1)"
                                              size={32}
                                              weight={800}
                                              style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                                            >
                                              {`${t("selfDiagnosis")}`}
                                            </MyText>
                </Row>
                                        
                <Row style={{ background: '#fff', borderRadius: '16px', padding: '10px 16px', border: '1px solid rgba(229, 233, 242, 1)' }}>
                  <MyText color="rgba(10, 3, 60, 1)" weight={700} size={32} style={{ fontFamily: 'Nunito', lineHeight: '40px' }}>
                  {`${ageId} ${getYearLabel(ageId)}`}
                  </MyText>
                </Row>
                </>
              )}
            </Row>
  
            <Row>
              <Col span={24}>
                <Spin spinning={surveysListState?.loading}>
                  <Row gutter={16}>
                    <Card style={{ height: '100%', width: '100%', borderRadius: '20px' }} styles={{ body: { height: '100%' } }}>
                      {currentQuestion ? (
                        <Form style={{ height: '100%' }}>
                          <Row justify="space-between" gutter={[0, 24]} style={{ flexDirection: 'column', height: '100%' }}>
                            <Row>
                              <MyText color="rgba(19, 15, 38, 1)" weight={800} size={32} style={{ fontFamily: 'Nunito', lineHeight: screens.xs ? '36px' : '48px' }}>
                              {`${t("chooseDirections")}`}
                              </MyText>
                            </Row>
                            <Col>
                              <Row gutter={[28, 28]}>
                                {questions.map((question: any, index: any) => {
                                  const isAnswered = answers.hasOwnProperty(question.id);
                                  const isCurrent = index === currentQuestionIndex;
                                  return (
                                    <Col span={12}>
                                    <Row align="middle" style={{ gap: '16px' }}>
                                        <CustomCheckbox
                                        checked={answers.hasOwnProperty(question.id)}
                                        onChange={(e) => handleCheckboxChange(question.id, e.target.checked)}
                                        />
                                        <MyText
                                        size={20}
                                        weight={400}
                                        style={{ display: 'block', lineHeight: screens.xs ? '24px' : '32px', cursor: 'pointer',...(isTablet && { flex: 1 })  }}
                                        onClick={() => handleCheckboxChange(question.id, !answers.hasOwnProperty(question.id))}
                                        >
                                        {question?.name}
                                        </MyText>
                                    </Row>
                                    </Col>
                                  );
                                })}
                              </Row>
                            </Col>
                          </Row>
                        </Form>
                      ) : (
                        <Spin loading={!!currentQuestion} />
                      )}
                      <Row align="center" style={{ marginTop: '38px', gap: '25px' }}>
                        <MyButton color="blue" type="primary" onClick={handleGoBack} style={{ padding: '28px 28px' }}>
                          <LeftOutlined />
                          <MyText color="#fff" weight={600} size={18} style={{ lineHeight: '24px' }}>
                          {`${t("back")}`}
                          </MyText>
                        </MyButton>
                        <MyButton
                          color="orange"
                          type="primary"
                          style={{ padding: '28px 28px' }}
                          disabled={Object.keys(answers).length === 0}
                          onClick={handleNext}
                        >
                          <MyText
                            color={Object.keys(answers).length === 0 ? "rgba(19, 15, 38, 1)" : "#fff"}
                            weight={600}
                            size={18}
                            style={{ lineHeight: '24px' }}
                          >
                            {`${t("next")}`}
                          </MyText>
                          <RightOutlined
                            style={{
                              color: Object.keys(answers).length === 0 ? "rgba(19, 15, 38, 1)" : "#fff",
                            }}
                          />
                        </MyButton>
                      </Row>
                    </Card>
                  </Row>
                </Spin>
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    );
  };
  